import { logWrapper } from '../utils';

export default {
  documentTypeModel: [
    'runtimeConstant',
    '$filter',
    function (runtimeConstant, $filter) {
      function DocumentType(data) {
        this.id = data ? data.Id : 0;
        this.idCompany = data ? data.IdCompany : 0;
        this.name = data ? data.Name : '';
        this.description = data ? data.Description : '';
        this.acronym = data ? data.Acronym : '';
        this.hasRevisionInterval = data
          ? data.RevisionInterval !== undefined &&
            data.RevisionInterval !== null
          : false;
        this.revisionInterval = data ? data.RevisionInterval : null;
        this.notificationDays = data ? data.NotificationDays : null;
        this.canOverrideRevInterval = data
          ? data.CanOverrideRevInterval
          : false;
        this.additionalFields = data
          ? data.DocumentTypesAdditionalFields
          : null;
        this.isTitle = data ? data.IsTitle : false;
        this.isTitleAdditional = data ? data.IsTitleAdditional : false;
        this.HasDocumentDate = data ? data.HasDocumentDate : false;
        this.selected = false;
      }

      function title() {
        return this.name;
      }

      function isTitle() {
        return this.isTitle;
      }

      function isTitleAdditional() {
        return this.isTitleAdditional;
      }

      function details() {
        return this.description;
      }

      function tags() {
        var tags = [$filter('translate')('ACRONYM TAG') + this.acronym];

        if (this.revisionInterval) {
          tags.push(
            $filter('translate')('REVISION INTERVAL TAG') +
              this.revisionInterval
          );
        }

        if (this.notificationDays) {
          tags.push(
            $filter('translate')('NOTIFICATION DAYS TAG') +
              this.notificationDays +
              (this.notificationDays > 1
                ? $filter('translate')('DAYS BEFORE TAG')
                : $filter('translate')('DAY BEFORE TAG'))
          );
        }

        if (this.canOverrideRevInterval) {
          tags.push($filter('translate')('CAN OVERRIDE REV INTERVAL TAG'));
        }

        return tags;
      }

      function isValid() {
        var isValid =
          this.name &&
          this.name.trim() !== '' &&
          this.acronym &&
          this.acronym.trim() !== '';

        if (this.hasRevisionInterval === true) {
          isValid =
            isValid &&
            this.revisionInterval &&
            this.revisionInterval !== '' &&
            this.revisionInterval > 0;
          isValid =
            isValid &&
            this.notificationDays &&
            this.notificationDays !== '' &&
            this.notificationDays > 0 &&
            parseInt(this.notificationDays) <= parseInt(this.revisionInterval);
        }

        return isValid;
      }

      function toggleAllFields(value) {
        if (arguments.length > 0) {
          this.allAdditionalFields.forEach(function (d) {
            d.selected = value;
          });
        } else {
          if (
            this.allAdditionalFields === undefined ||
            this.allAdditionalFields === null
          ) {
            return false;
          }

          return this.allAdditionalFields.every(function (d) {
            return d.selected === true;
          });
        }
      }

      function run() {
        try {
          DocumentType.prototype = {
            title: logWrapper(title, runtimeConstant.isDebugModelsInternals),
            isTitle: logWrapper(
              isTitle,
              runtimeConstant.isDebugModelsInternals
            ),
            isTitleAdditional: logWrapper(
              isTitleAdditional,
              runtimeConstant.isDebugModelsInternals
            ),
            details: logWrapper(
              details,
              runtimeConstant.isDebugModelsInternals
            ),
            tags: logWrapper(tags, runtimeConstant.isDebugModelsInternals),
            isValid: logWrapper(
              isValid,
              runtimeConstant.isDebugModelsInternals
            ),
            toggleAllFields: logWrapper(
              toggleAllFields,
              runtimeConstant.isDebugModelsInternals
            ),
          };

          return DocumentType;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
